<div class="d-flex justify-content-center align-items-center">
  <img src="/assets/images/poweredby-OneEquineblack-logo.png" style="height: 60px;">
</div>